<template>
  <div class="layer manageLayer">
    <div class="inner">
      <button type="button" class="btnClose" @click="toggleManage"><span class="blind">close</span></button>
      <h2 class="layerTitle">{{locale.setting_management_product}}</h2>
      <div class="listHeader row">
        <span class="name">
          {{locale.product_id}} ({{locale.name}})
          <input type="text" class="input filterInput" :placeholder="locale.management_product_search" v-model="filter" />
          <button type="button" class="btnReload" @click="reload"><span class="blind">reload</span></button>
        </span>
        <span class="qty">{{locale.quantity}}</span>
      </div>
      <ul class="list">
        <li v-for="(item, index) in list"
          :key="index"
          :class="{ghost: item.ghost, warn: warn(item)}">
          <span class="checkbox radio">
            <input
              type="radio"
              name="product_manage"
              :id="`${index}_manage_${item.pid}`"
              :value="item.pid"
              :checked="isChecked(item.pid)"
              @change="onChange(item)">
            <label :for="`${index}_manage_${item.pid}`" class="row">
              <span class="name">
                {{itemLabel(item)}}
              </span>
              <span class="qty">
                {{item.inventory ? item.qty : '-'}}
              </span>
            </label>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'ManageProduct',
  props: [
    'locale',
    'manage',
    'productList',
    'productItem'
  ],
  computed: {
    manageProduct () {
      const list = this.$store.getters['product/getManageProduct']
      const productList = this.productList
      const listByProduct = list.map(x => {
        const assign = productList.filter(p => p.manage && p.manageInfo && p.manageInfo.pId === x.pid).map(r => r.id)
        return {
          ...x,
          assign: assign
        }
      })
      return listByProduct
    },
    list () {
      const word = findWord(this.filter)
      const manageProduct = this.manageProduct
      const filteredList = manageProduct.filter(x => findWord(x.pid).includes(word) || findWord(x.pname).includes(word))
      const unfilteredList = manageProduct.filter(x => !findWord(x.pid).includes(word) && !findWord(x.pname).includes(word)).map(x => {
        return {
          ...x,
          ghost: true
        }
      })
      function findWord (string) {
        return string ? regExp.replaceAllEmpty(string) : ''
      }
      return word.length ? filteredList.concat(unfilteredList) : manageProduct
    }
  },
  created () {
    this.reload()
  },
  data () {
    return {
      filter: ''
    }
  },
  methods: {
    itemLabel (item) {
      const pid = item.pid
      const pname = item.pname ? `(${item.pname})` : ''
      return pid + pname
    },
    onChange (item) {
      this.$emit('change', item)
    },
    toggleManage () {
      this.$emit('close')
    },
    warn (item) {
      return item.qty <= 0
    },
    isChecked (pid) {
      return this.manage && this.manage.pId === pid
    },
    disabled (item) {
      return item.assign.length > 0 && !item.assign.includes(this.productItem)
    },
    reload () {
      this.filter = ''
      this.$store.dispatch('product/getManageProduct')
    }
  }
}
</script>

<style lang="scss" scoped>
.manageLayer {
  .filterInput {
    flex: 1;
    height: 30px;
    max-width: 240px;
    margin-left: 5px;
    font-weight: normal;
  }
  .listHeader {
    padding: 0 0.5em 0.5em;
    font-weight: bold;
  }
  .list {
    max-height: 100%;
    min-height: 200px;
    overflow: auto;
    border: 1px solid $color-lgrey2;
    li {
      .checkbox {
        margin: 0;
      }
      label {
        padding: 0.5em;
        &:hover {
          background-color: $color-white;
        }
        &:before {
          position: static;
          margin-right: 5px;
        }
      }
      & + li {
        border-top: 1px solid $color-lgrey2;
      }
    }
    .ghost {
      opacity: 0.3;
    }
    .disabled {
      .checkbox label:before {
        background-color: $color-lgrey2;
      }
    }
    .warn {
      color: $color-red;
    }
  }
  .row {
    display: flex;
    align-items: center;
    .name {
      flex: 1;
    }
    .qty {
      margin-left: auto;
    }
  }
  .btnReload {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    border: 1px solid $color-lgrey2;
    background: $color-white url('~@/assets/img/ico_reload.svg') 50% 50% / 18px no-repeat;
    &:active {
      box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    }
  }
}
</style>
